// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab--active[data-v-14259d14]{background-color:var(--v-primary-base)!important;border-radius:50px;color:#fff!important}.sticky-md[data-v-14259d14]{position:sticky;z-index:2}", ""]);
// Exports
module.exports = exports;
